export function wizardConfig({ colors }) {
    return {
        step: {
            border: `1px solid ${colors.divider.colorSubtle}`
        },
        tip: {
            color: colors.divider.colorSubtle
        }
    };
}
